// extracted by mini-css-extract-plugin
export default {"image_container":"ProducerImage_image_container__4UAof","producer_image":"ProducerImage_producer_image__W-WnB","grey_circle":"ProducerImage_grey_circle__0gs9+"};